import React from 'react'
import { Location } from '@reach/router'
import queryString from 'query-string'
import { initializeUrlSlugs } from '../../utils/UrlUtils'

export const withUrlSlugs = (ComponentToWrap: any) => (props: any) => {
  const result = initializeUrlSlugs()
  return <ComponentToWrap {...props} />
}
